<template>
    <div
        class="pdf-page-stream"
        :style="elementStyle"
    >
        <slot v-bind="{ loaded }"></slot>
    </div>
</template>

<script>
const pdfjsViewer = require('qys-pdfjs/web/pdf_viewer')

export default {
    name: 'PdfPageStream',
    props: {
        scale: Number,
        page: Object,
        viewport: Object,
        elementStyle: Object,
        inScrollView: Boolean,
        isScrolling: Boolean,
        watermarkText: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            pdfViewer: null,
            loaded: false,
        };
    },
    computed: {
        visibility () {
            return !this.isScrolling && this.inScrollView;
        }
    },
    watch: {
        visibility: {
            handler (nv) {
                nv && this.renderContent();
            },
            immediate: true
        },
        scale: {
            handler () {
                this.updatePdfRender();
            }
        }
    },
    methods: {
        /** 绘制水印 */
        paintWaterMark (ctx) {
            if (!this.watermarkText) return;
            ctx.font = '18px Microsoft YaHei';
            ctx.fillStyle = 'rgba(211, 210, 211, 0.3)';
            for (let i = 0; i < 200; i++) {
                ctx.save();
                ctx.translate(400 * (i % 5), 373 * parseInt((i / 5).toString()));
                ctx.rotate(-(Math.PI * (1 / 4)));
                ctx.fillText(this.watermarkText, 0, 0);
                ctx.restore();
            }
        },

        drawContent () {
            this.pdfViewer.draw().then(() => {
                this.loaded = true;
                this.$listeners['page-rendered'] && this.$listeners['page-rendered'].call(null, this.pageNumber)
                // 绘制水印
                if (this.watermarkText) {
                    const context = this.pdfViewer.canvas.getContext("2d");
                    this.paintWaterMark(context)
                }
            }).catch((error) => {
                this.$listeners['page-render-error'] && this.$listeners['page-render-error'].call(null, this.pageNumber, error)
            });
        },

        /** 使用默认方式渲染 */
        renderContent () {
            if (this.loaded) return;
            // 渲染任务 通过onlyCanvas 配置是否需要html DOM节点
            this.pdfViewer = new pdfjsViewer.PDFPageView({
                container: this.$el,
                eventBus: {
                    dispatch: () => { },
                    _on: () => { },
                    _off: () => { }
                },
                id: this.page.pageNumber,
                scale: this.scale,
                textLayerMode: false,
                renderInteractiveForms: false,
                useOnlyCssZoom: false,
                maxCanvasPixels: 5242880,
                defaultViewport: this.viewport,
            });

            this.pdfViewer.setPdfPage(this.page);
            this.drawContent();
        },

        /** 重置渲染实例 销毁DOM节点 */
        resetpdfViewer () {
            if (!this.pdfViewer) return;
            this.pdfViewer.reset(false, false, true);
        },

        /** 更新 pdfscale */
        updatePdfRender () {
            if (this.loaded && this.pdfViewer) {
                this.loaded = false;
                this.destorypdfViewer();
                this.pdfViewer.scale = this.scale;
                this.pdfViewer.setPdfPage(this.page);
                this.drawContent();
            }
        },

        /** 销毁pdf实例 */
        destorypdfViewer () {
            this.pdfViewer?.destroy?.();
        },
    },
    beforeDestroy () {
        this.destorypdfViewer();
    },
};
</script>

<style lang="less" scoped>
.pdf-page-stream {
    position: relative;
    user-select: none;
    overflow: hidden;
}
</style>
